export class CheckIfExistsFarmDapUseCase {
    constructor(farmsDapRepository) {
      this.farmsDapRepository=farmsDapRepository
    }
    async execute(ID_FARM) {
      // ID_FARM  -> ID do Cultivar
      //Verificar se existe cultivares com ID_FARM no banco
    const farms = await this.farmsDapRepository.checkIfExistsFarmDap(ID_FARM)
      return farms
    }
  }
  